import { Link } from 'react-router-dom';

const Footer = () => {
  const currentYear = new Date().getFullYear();
  
  return (
    <footer className="bg-white dark:bg-gray-900 border-t border-gray-200 dark:border-gray-700">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        {/* Main Footer Content */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-8">
          {/* Brand Section */}
          <div className="footer-section">
            <h3 className="text-2xl font-bold text-gray-900 dark:text-white mb-4">
              Kola Lead Capture
            </h3>
            <p className="text-gray-600 dark:text-gray-300 leading-relaxed">
              Efficient lead management for your business growth and success.
            </p>
          </div>
          
          {/* Contact Section */}
          <div className="footer-section">
            <h4 className="text-lg font-semibold text-gray-900 dark:text-white mb-4">
              Contact Info
            </h4>
            <div className="space-y-2">
              <a 
                href="mailto:info@kolaleads.com"
                className="text-gray-600 dark:text-gray-300 hover:text-primary-600 dark:hover:text-primary-400 transition-colors duration-200 flex items-center gap-2"
              >
                <span aria-hidden="true">📧</span>
                <span>info@kolaleads.com</span>
              </a>
              <a 
                href="tel:5551234567"
                className="text-gray-600 dark:text-gray-300 hover:text-primary-600 dark:hover:text-primary-400 transition-colors duration-200 flex items-center gap-2"
              >
                <span aria-hidden="true">📞</span>
                <span>(555) 123-4567</span>
              </a>
            </div>
          </div>
          
          {/* Quick Links Section */}
          <div className="footer-section">
            <h4 className="text-lg font-semibold text-gray-900 dark:text-white mb-4">
              Quick Links
            </h4>
            <div className="space-y-2">
              <Link 
                to="/"
                className="text-gray-600 dark:text-gray-300 hover:text-primary-600 dark:hover:text-primary-400 transition-colors duration-200 block hover:translate-x-1 transform"
              >
                Home
              </Link>
            </div>
          </div>
        </div>
        
        {/* Footer Bottom */}
        <div className="border-t border-gray-200 dark:border-gray-700 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center">
            <p className="text-gray-500 dark:text-gray-400 text-sm mb-4 md:mb-0">
              &copy; {currentYear} created by{' '}
              <a 
                href="https://www.linkedin.com/in/mrrileyjordan/" 
                target="_blank" 
                rel="noopener noreferrer"
                className="underline hover:text-primary-600 dark:hover:text-primary-400 transition-colors duration-200"
              >
                Riley Jordan
              </a>
            </p>
            <div className="flex space-x-6">
              <a 
                href="https://www.linkedin.com/in/mrrileyjordan/" 
                target="_blank" 
                rel="noopener noreferrer"
                className="text-gray-400 hover:text-[#0077B5] dark:hover:text-[#0077B5] transition-colors duration-200"
                aria-label="Visit Riley Jordan's LinkedIn profile"
              >
                <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24" aria-hidden="true">
                  <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"/>
                </svg>
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;